module.exports = __webpack_public_path__ + "fonts/GalanoGrotesque-SemiBold.e5221a0.woff";